import { FindAllSsoProvidersResponseDto, SsoProviderService } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

export const fetchAllSsoProvidersForExport = async (
  call: TCall,
  search: string,
): Promise<FindAllSsoProvidersResponseDto> => {
  const baseExportParams = {
    pageNo: '1',
    orderBy: 'createdAt',
    orderType: 'desc',
    search,
  };
  const countResponse = await call(() =>
    SsoProviderService.findAll({
      ...baseExportParams,
      pageSize: '1',
    }),
  );

  if (countResponse.count === 0) {
    return { count: 0, data: [] };
  }

  return call(() =>
    SsoProviderService.findAll({
      ...baseExportParams,
      pageSize: countResponse.count.toString(),
    }),
  );
};
